package com.milta.core.localization

/**
 * Strings for the Admin "Prompts" dashboard screen (web-only, Enterprise back-office — see
 * [com.milta.web.AdminPromptsContent]). The locked contract footer itself is server-supplied data
 * (prompt.contractFooter), not a translatable literal — only the chrome around it lives here.
 */
data class AdminPromptsStrings(
    val loading: String,
    val errorNoConnection: String,
    val errorGeneric: String,
    val contractLockedNotice: String,
    val notModifiedLabel: String,
    /** Composed in code as "$modifiedOnPrefix ${formatDate(...)}". */
    val modifiedOnPrefix: String,
    val resetToDefaultAction: String,
    val editableBodyLabel: String,
    val markdownBoldSnippet: String,
    val markdownItalicSnippet: String,
    val markdownCodeSnippet: String,
    val markdownHeadingSnippet: String,
    val markdownBulletSnippet: String,
    val markdownNumberedSnippet: String,
    val markdownQuoteSnippet: String,
    val previewToggleEdit: String,
    val previewToggleShow: String,
    val contractFooterLabel: String,
    val actionErrorOffline: String,
    val actionErrorGeneric: String,
    val unsavedChangesNotice: String,
    val savingAction: String,
    val saveAction: String,
)
